module.exports = __webpack_public_path__ + "images/mmm-02-desktop.png";